import LPVivazConnection from './LPVivazConnection'

export default LPVivazConnection


// WEBPACK FOOTER //
// ./src/components/containers/LPVivazConnection/index.js